module.exports = __webpack_public_path__ + "media/images/services-img-4-913edfaf769750667aa82a8cdfdbeaec.png";